<template>
  <el-menu
    :default-active="defaultActive"
    background-color="transparent"
    router
    text-color="#fff"
    mode="horizontal"
    class="nav-side"
    width="1000px"
  >
    <el-submenu
      v-if="navItem.subList"
      v-for="(navItem, navItemIndex) in navList"
      :index="navItemIndex + ''"
      :key="navItemIndex"
    >
      <template slot="title">{{navItem.navText}}</template>
      <el-menu-item
        v-for="(subtItem, subtItemIndex) in navItem.subList"
        :index="subtItem.navLink"
        :key="navItemIndex + '-' + subtItemIndex"
      >{{subtItem.navText}}</el-menu-item>
    </el-submenu>
    <el-menu-item v-else :index="navItem.navLink">{{navItem.navText}}</el-menu-item>
  </el-menu>
</template>

<script>
export default {
  data() {
    return {
      navList: [
        {
          navText: "行业解决案例",
          navLink: "/home"
        },
        // {
        //   navText: "行业解决案例",
        //   navLink: "/products"
        // },
        {
          navText: "服务支持",
          navLink: "/support"
        }
      ],
      defaultActive: ""
    };
  },
  mounted() {
    this.defaultActive = this.$route.fullPath;
  },
  watch: {
    $route(to, from) {
      this.defaultActive = this.$route.fullPath;
    }
  }
};
</script>

<style scoped lang="stylus">
.el-menu--horizontal .el-menu-item:not(.is-disabled):focus, .el-menu--horizontal .el-menu-item:not(.is-disabled):hover
  background-color rgba(255, 255, 255, 0.1) !important
  color #fff
.nav-side
  width 1000px
  padding 0 20px
.el-menu--horizontal>.el-menu-item.is-active
  color #fff
  background-color rgba(255, 255, 255, 0.1) !important
.el-menu.el-menu--horizontal
  border none
</style>



// WEBPACK FOOTER //
// src/components/nav/nav.vue